export default "__VITE_ASSET__BxrQjYGc__"